import {Col, Form, Row} from 'react-bootstrap'
import { QueryResponseProvider } from './states-list/core/QueryResponseProvider'
import { StatesListWrapper } from './states-list/StatesList'
import AddEditState from './AddEditState'
import { checkPermission } from 'app/utils/checkPermission'

const State = () => {
  return (
    <div>
      <QueryResponseProvider>
        <Row className='gx-5'>
          {checkPermission('States', 'create') ?(
            <>
          <Col md={4} sm={12}>
            <AddEditState isEditing={false} id={""} handleClose={()=>{}}/>
          </Col>
          <Col md={8} sm={12}>
            <Form noValidate className='border p-3' id='kt_modal_add_user_form'>
              <Col className='card-label font-weight-bolder text-dark font-size-h5 mb-6 '>
                <StatesListWrapper />
              </Col>
            </Form>
          </Col>
          </>
          ):(<>
            <Col md={12} sm={12}>
             <Form noValidate className='border p-3' id='kt_modal_add_user_form'>
               <Col className='card-label font-weight-bolder text-dark font-size-h5 mb-6 '>
               <StatesListWrapper />
               </Col>
             </Form>
           </Col>
           </>)}
        </Row>
      </QueryResponseProvider>
    </div>
  )
}

export default State
